export default __webpack_public_path__ + "static/media/after.6786a20e.png";